import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "chips"]
  static values = {
    maxTags: { type: Number, default: 10 },
    maxLength: { type: Number, default: 30 }
  }

  connect() {
    this.tags = this.parseInitialTags()
    this.render()
  }

  parseInitialTags() {
    const value = this.hiddenTarget.value
    if (!value) return []
    return value.split(",").map(t => t.trim()).filter(Boolean)
  }

  addTag(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      let value = this.inputTarget.value.trim().replace(/,/g, "")

      // Enforce max tag length
      if (value.length > this.maxLengthValue) {
        value = value.slice(0, this.maxLengthValue)
      }

      if (value && !this.tags.includes(value)) {
        if (this.tags.length >= this.maxTagsValue) return
        this.tags.push(value)
        this.update()
      }
      this.inputTarget.value = ""
    }

    // Backspace to remove last tag
    if (event.key === "Backspace" && !this.inputTarget.value && this.tags.length) {
      this.tags.pop()
      this.update()
    }
  }

  removeTag(event) {
    const tag = event.currentTarget.dataset.tag
    this.tags = this.tags.filter(t => t !== tag)
    this.update()
  }

  update() {
    this.hiddenTarget.value = this.tags.join(", ")
    this.render()
    // Dispatch input event for autosave
    this.hiddenTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  render() {
    const html = this.tags.map(tag => `
      <span class="chip">
        ${this.escapeHtml(tag)}
        <button type="button" class="chip-remove" data-action="click->tag-input#removeTag" data-tag="${this.escapeHtml(tag)}">&times;</button>
      </span>
    `).join("")
    this.chipsTarget.innerHTML = html

    // Disable input when max tags reached
    if (this.tags.length >= this.maxTagsValue) {
      this.inputTarget.disabled = true
      this.inputTarget.placeholder = `Max ${this.maxTagsValue} tags`
    } else {
      this.inputTarget.disabled = false
      this.inputTarget.placeholder = this.inputTarget.dataset.originalPlaceholder || "Add tag..."
    }
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
